import {Cpu} from "./cpu";
import {Psu} from "./psu";

export class Triggers {

  constructor(
    public startupTime: number,
    public startTime: number,
    public endTime: number,
    public closedownTime: number
  ) {}

  static toTriggers(json: any) : Triggers {
    if ( json === null ) {
      return null;
    } else {
      return new Triggers(json.startupTime, json.startupTime, json.endTime, json.closedownTime);
    }
  }
}

